export const services = [
  {
    id: 1,
    title: "US Trademark Registration",
    subtitle: "Federal Brand Protection",
    description: "Stop waiting. Every day your brand goes unregistered is another day someone can steal it. Our trademark attorneys file your USPTO application fast and fight to get it approved.",
    icon: "Shield",
    features: [
      "Full USPTO application & filing",
      "Licensed trademark attorney review",
      "Office action response handling",
      "Federal registration certificate"
    ],
    span: "lg:col-span-2 lg:row-span-2"
  },
  {
    id: 2,
    title: "Copyright Registration",
    subtitle: "Creative Work Protection",
    description: "Your content, images, and digital assets are being copied right now. Register your copyrights before someone else profits from your work.",
    icon: "FileText",
    features: [
      "US Copyright Office filing",
      "Digital content protection",
      "Official copyright certificate",
      "Legal enforcement rights"
    ]
  },
  {
    id: 3,
    title: "Company Formation",
    subtitle: "LLC & Corporation Setup",
    description: "No LLC means no legal protection. We set up your business entity across all 50 states, including EIN, registered agent, and operating agreements.",
    icon: "Building",
    features: [
      "LLC and Corporation setup",
      "EIN / Tax ID registration",
      "Registered agent service",
      "Operating agreement prep"
    ]
  },
  {
    id: 4,
    title: "Trademark Search",
    subtitle: "Conflict Analysis",
    description: "Filing blind is throwing money away. Our comprehensive search catches conflicts the USPTO will flag, saving you months of rejection headaches.",
    icon: "Search",
    features: [
      "Full USPTO database scan",
      "State registry check",
      "Common law research",
      "Detailed conflict report"
    ]
  },
  {
    id: 5,
    title: "Amazon Brand Registry",
    subtitle: "Seller Brand Enrollment",
    description: "Without Brand Registry, Amazon sellers lose thousands to hijackers and counterfeiters. We get you enrolled fast with our combined trademark + registry service.",
    icon: "Package",
    features: [
      "Complete Brand Registry enrollment",
      "Trademark filing for Amazon",
      "A+ Content & Brand tools access",
      "IP protection activation"
    ],
    highlighted: true
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Starter",
    price: "$45",
    federal: "+ Federal Filing Fee",
    recommended: false,
    tagline: "For simple, single-class filings",
    features: [
      "Case review & evaluation",
      "USPTO application filing",
      "Basic trademark search",
      "State e-filing included",
      "Email status updates"
    ],
    note: "(USPTO govt. fee not included)",
    buttonText: "Start Now"
  },
  {
    id: 2,
    name: "Professional",
    price: "$149",
    federal: "+ Federal Filing Fee",
    recommended: false,
    tagline: "For brands that need conflict analysis",
    features: [
      "Everything in Starter",
      "Direct-hit conflict search",
      "Trademark monitoring alerts",
      "Refusal risk assessment",
      "Priority email support",
      "Application status dashboard"
    ],
    note: "(USPTO govt. fee not included)",
    buttonText: "Choose Professional"
  },
  {
    id: 3,
    name: "Business",
    price: "$299",
    federal: "+ Federal Filing Fee",
    recommended: true,
    tagline: "Most popular - full protection",
    features: [
      "Everything in Professional",
      "Comprehensive search report",
      "Dedicated case manager",
      "Office action response",
      "1-year trademark monitoring",
      "Complete documentation",
      "Phone & email support"
    ],
    note: "(USPTO govt. fee not included)",
    buttonText: "Get Business Plan"
  },
  {
    id: 4,
    name: "Enterprise",
    price: "$349",
    federal: "+ Federal Filing Fee",
    recommended: false,
    tagline: "For serious brand protection",
    features: [
      "Everything in Business",
      "Full clearance search report",
      "Priority fast-track processing",
      "Cease & desist letter",
      "Trademark renewal reminder",
      "Multi-class filing support",
      "Dedicated attorney access",
      "Brand protection strategy"
    ],
    note: "(USPTO govt. fee not included)",
    buttonText: "Choose Enterprise"
  }
];

export const workProcess = [
  {
    id: 1,
    step: "01",
    title: "Tell Us About Your Brand",
    description: "Fill out a quick form or call us. We run a thorough trademark search across USPTO databases within 24 hours and tell you exactly where you stand."
  },
  {
    id: 2,
    step: "02",
    title: "We File Your Application",
    description: "Our trademark attorneys prepare and file your application with precise classification and complete documentation. No guesswork, no errors, no delays."
  },
  {
    id: 3,
    step: "03",
    title: "You Get Your Trademark",
    description: "We handle every office action, monitor every stage, and don't stop until your federal trademark registration certificate is in your hands."
  }
];

export const whyChooseUs = [
  {
    id: 1,
    icon: "Scale",
    title: "Licensed Trademark Attorneys",
    description: "Not paralegals. Not bots. Real, licensed trademark attorneys review every application and respond to every office action."
  },
  {
    id: 2,
    icon: "Wallet",
    title: "Flat-Rate Pricing. Period.",
    description: "No hourly fees. No surprise charges. No hidden costs. You see the exact price before you pay a single dollar."
  },
  {
    id: 3,
    icon: "Headphones",
    title: "A Real Human On Your Side",
    description: "Your dedicated case manager picks up the phone, answers your emails, and gives you real-time updates. Not a chatbot."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    role: "E-commerce Entrepreneur",
    service: "Trademark Registration",
    content: "I almost lost my brand name to a competitor. Trademark My LLC filed my application in 48 hours and saved my entire business. If you're waiting, you're already behind.",
    rating: 5
  },
  {
    id: 2,
    name: "Michael C.",
    role: "Startup Founder",
    service: "Trademark Search",
    content: "Their search found 3 conflicts I had no idea about. If I had filed on my own, I would have wasted $350 in USPTO fees and 12 months waiting for a rejection.",
    rating: 5
  },
  {
    id: 3,
    name: "Jennifer R.",
    role: "Amazon Seller",
    service: "Amazon Brand Registry",
    content: "Hijackers were eating my listings alive. Within weeks of getting Brand Registry through Trademark My LLC, I had full control back. Sales jumped 40%.",
    rating: 5
  },
  {
    id: 4,
    name: "David T.",
    role: "Product Designer",
    service: "Copyright Registration",
    content: "Someone was selling my designs on Etsy. Copyright registration gave me the legal teeth to shut them down permanently. Should have done this years ago.",
    rating: 5
  },
  {
    id: 5,
    name: "Amanda S.",
    role: "Small Business Owner",
    service: "Company Formation",
    content: "LLC + trademark in one package. Done in under a week. I was expecting months of paperwork. These guys don't mess around.",
    rating: 5
  },
  {
    id: 6,
    name: "Robert W.",
    role: "Online Retailer",
    service: "Trademark Registration",
    content: "Best $45 I ever spent. My brand is now federally protected across all 50 states. The peace of mind alone is worth ten times the price.",
    rating: 5
  },
  {
    id: 7,
    name: "Emily P.",
    role: "Fashion Brand Owner",
    service: "Trademark Registration",
    content: "Counterfeit sellers were destroying my brand. The Enterprise package's cease and desist service paid for itself on day one. Non-negotiable investment.",
    rating: 5
  },
  {
    id: 8,
    name: "James A.",
    role: "Tech Startup CEO",
    service: "Company Formation",
    content: "They handled LLC formation and trademark simultaneously. Zero friction. Everything was done before my product even launched. That's how you start a company.",
    rating: 5
  }
];

export const blogPosts = [
  {
    id: 1,
    slug: "trademark-application-mistakes",
    title: "5 Costly Mistakes That Get Trademark Applications Rejected",
    excerpt: "Over 30% of trademark applications are rejected by the USPTO. Here are the top 5 filing errors that cost business owners months of delays and hundreds in wasted fees.",
    category: "Trademark Tips",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1769029265788-d7921a103403?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxsZWdhbCUyMGdhdmVsJTIwY291cnRob3VzZSUyMGxhdyUyMGp1c3RpY2V8ZW58MHx8fHwxNzc1MjQ2OTE5fDA&ixlib=rb-4.1.0&q=85",
    content: [
      { type: "paragraph", text: "Filing a trademark application with the USPTO seems straightforward, but the reality is that over 30% of applications are rejected. Each rejection means wasted filing fees, months of delays, and starting the process over. Here are the five most common mistakes that lead to rejection and how to avoid them." },
      { type: "heading", text: "1. Choosing a Descriptive or Generic Mark" },
      { type: "paragraph", text: "The USPTO rejects marks that merely describe the goods or services being offered. If your brand name directly tells consumers what the product is or does, it will likely be refused. For example, trying to trademark 'Fast Delivery Service' for a shipping company would fail because it describes the service rather than identifying a unique brand. Choose distinctive, suggestive, or arbitrary names that stand out from the competition." },
      { type: "heading", text: "2. Filing in the Wrong Trademark Class" },
      { type: "paragraph", text: "The USPTO uses 45 different classes to categorize goods and services. Filing under the wrong class is one of the most common errors and results in an office action or outright rejection. Each class has specific requirements, and misclassification means your trademark won't protect what you actually sell. A trademark attorney can identify the correct class and ensure your application covers everything you need." },
      { type: "heading", text: "3. Ignoring Existing Similar Marks" },
      { type: "paragraph", text: "The USPTO examiner will compare your mark against all existing registrations. If there's a 'likelihood of confusion' with an existing mark, your application will be refused. Many applicants skip the comprehensive trademark search and file blind, only to discover months later that a similar mark already exists. A thorough search before filing saves time, money, and frustration." },
      { type: "heading", text: "4. Submitting an Improper Specimen" },
      { type: "paragraph", text: "A specimen is evidence showing how you actually use the mark in commerce. The USPTO has strict requirements for what qualifies as an acceptable specimen. Website screenshots, product packaging, and labels are common specimens, but they must show the mark used in connection with the specific goods or services listed in the application. Mock-ups, digitally altered images, or invoices alone are typically rejected." },
      { type: "heading", text: "5. Writing a Vague or Overly Broad Description" },
      { type: "paragraph", text: "Your description of goods and services must be specific enough for the USPTO to understand exactly what your mark covers. Descriptions that are too vague will trigger an office action, while descriptions that are too broad may create conflicts with existing marks. The key is precision: clearly state what you sell without overreaching into categories you don't actually serve." },
      { type: "paragraph", text: "Avoiding these five mistakes dramatically increases your chances of a successful trademark registration. At Trademark My LLC, our licensed attorneys handle every aspect of the application process, from comprehensive search to precise classification, ensuring your application is done right the first time." }
    ]
  },
  {
    id: 2,
    slug: "amazon-brand-registry-guide",
    title: "Amazon Brand Registry 2026: The Complete Seller's Guide",
    excerpt: "Amazon just updated Brand Registry requirements. If you sell on Amazon without it, you're losing money every single day. Here's exactly how to get enrolled fast.",
    category: "Amazon Sellers",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1580674285054-bed31e145f59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxlY29tbWVyY2UlMjBzaGlwcGluZyUyMGJveGVzJTIwcGFja2FnZXMlMjB3YXJlaG91c2V8ZW58MHx8fHwxNzc1MjQ2OTE5fDA&ixlib=rb-4.1.0&q=85",
    content: [
      { type: "paragraph", text: "Amazon Brand Registry is no longer optional for serious sellers. Without it, you're leaving money on the table and your listings unprotected. In 2026, Amazon has tightened requirements and expanded the tools available to registered brands. Here's everything you need to know to get enrolled." },
      { type: "heading", text: "What Is Amazon Brand Registry?" },
      { type: "paragraph", text: "Amazon Brand Registry is a program that gives brand owners access to powerful tools for protecting and building their brand on Amazon. It requires a registered trademark (or a pending application with a serial number) to enroll. Once enrolled, you unlock A+ Content, Sponsored Brands advertising, Amazon Stores, and automated intellectual property protection." },
      { type: "heading", text: "Why You Need It in 2026" },
      { type: "paragraph", text: "Counterfeiters and hijackers cost Amazon sellers billions every year. Without Brand Registry, you have almost no recourse when someone copies your listing, uses your brand name, or sells counterfeit versions of your product. Brand Registry gives you the ability to report violations, automatically detect infringements, and control your product listings across Amazon's marketplace." },
      { type: "heading", text: "Requirements for Enrollment" },
      { type: "paragraph", text: "To enroll in Amazon Brand Registry, you need: (1) A registered trademark with the USPTO or a pending application with a serial number, (2) The trademark must be a text-based mark or an image-based mark with text, (3) You must be the trademark owner or an authorized agent, (4) An active Amazon Seller Central or Vendor Central account. The trademark must match exactly what appears on your Amazon products." },
      { type: "heading", text: "Tools You Unlock With Brand Registry" },
      { type: "paragraph", text: "A+ Content (Enhanced Brand Content) lets you add rich media, comparison charts, and branded storytelling to your product detail pages, increasing conversion rates by up to 10%. Sponsored Brands ads place your logo and products at the top of search results. Amazon Stores give you a multi-page storefront. Brand Analytics provides valuable data on search terms, demographics, and competitor performance. Automated IP protection uses machine learning to find and remove suspected infringements." },
      { type: "heading", text: "How Trademark My LLC Gets You Enrolled Fast" },
      { type: "paragraph", text: "We combine trademark filing with Brand Registry enrollment into a single streamlined service. Our attorneys file your USPTO application, ensure it meets Amazon's requirements, and guide you through the enrollment process once your serial number is issued. Most clients receive their serial number within 2-4 weeks of filing, allowing them to begin the Brand Registry application immediately." }
    ]
  },
  {
    id: 3,
    slug: "trademark-vs-copyright-vs-patent",
    title: "Trademark vs Copyright vs Patent: What Your Business Actually Needs",
    excerpt: "Most business owners confuse these three. Pick the wrong protection and you're exposed. This breakdown tells you exactly which one covers what.",
    category: "Legal Guide",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1687289133469-b2a07a13b78b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxzY2FsZXMlMjBvZiUyMGp1c3RpY2UlMjBsYXclMjBib29rcyUyMGxpYnJhcnl8ZW58MHx8fHwxNzc1MjQ2OTI3fDA&ixlib=rb-4.1.0&q=85",
    content: [
      { type: "paragraph", text: "Trademarks, copyrights, and patents are three distinct forms of intellectual property protection. Most business owners confuse them, and choosing the wrong type of protection means critical parts of your business remain exposed. Here's a clear breakdown of what each one covers and which ones your business actually needs." },
      { type: "heading", text: "Trademarks: Protecting Your Brand Identity" },
      { type: "paragraph", text: "A trademark protects brand identifiers: your business name, logo, slogan, and any symbol that distinguishes your products or services from competitors. Trademark registration with the USPTO gives you exclusive nationwide rights to use that mark in your industry. It's essential for any business that wants to build brand recognition and prevent others from trading on your reputation. For Amazon sellers, a registered trademark is required for Brand Registry enrollment." },
      { type: "heading", text: "Copyrights: Protecting Your Creative Work" },
      { type: "paragraph", text: "Copyright protects original creative works: written content, photographs, videos, music, software code, product descriptions, and graphic designs. Copyright protection exists automatically when you create something, but registering with the US Copyright Office gives you the legal standing to sue for damages and is required before you can take legal action against infringers. For e-commerce sellers, copyright registration protects your product images, listing descriptions, and marketing content from being stolen by competitors." },
      { type: "heading", text: "Patents: Protecting Your Inventions" },
      { type: "paragraph", text: "A patent protects inventions and functional innovations: new products, processes, machines, and chemical compositions. Patents are the most complex and expensive form of IP protection, typically costing $5,000-$15,000+ and taking 2-3 years to process. They're essential if you've invented something genuinely new and want to prevent others from making, using, or selling it. Most small businesses don't need patents unless they've developed a novel product or technology." },
      { type: "heading", text: "What Does Your Business Need?" },
      { type: "paragraph", text: "Almost every business needs a trademark. If you have a brand name, you need to protect it. Period. If you create content, images, or designs, you should also register copyrights for your most valuable creative assets. Patents are only necessary if you've invented something that doesn't already exist. For Amazon sellers, the priority should be: (1) Trademark registration for Brand Registry, (2) Copyright registration for product images and listing content, (3) Patent only if you have a truly novel product invention." },
      { type: "heading", text: "Start With Trademark Registration" },
      { type: "paragraph", text: "At Trademark My LLC, we help businesses prioritize the right protection. For most clients, that starts with trademark registration. Starting at just $45, it's the most cost-effective way to secure your brand identity and unlock critical tools like Amazon Brand Registry. From there, we can add copyright registration and company formation services as your business grows." }
    ]
  }
];

export const faqs = [
  {
    id: 1,
    question: "How fast can you file my trademark?",
    answer: "We file most applications within 24-48 hours of receiving your information. The full USPTO process takes 8-12 months, but we start protecting your brand immediately. Our team prioritizes speed because every day without a filing is a risk."
  },
  {
    id: 2,
    question: "What happens if someone is already using my brand name?",
    answer: "That's exactly why we run a comprehensive trademark search first. If conflicts exist, we'll tell you upfront and recommend the best course of action, whether that's modifying your mark, filing in a different class, or pursuing the registration aggressively. You won't waste a dime filing blind."
  },
  {
    id: 3,
    question: "Is the $45 Starter package really enough?",
    answer: "For straightforward, single-class filings with low conflict risk, absolutely. It includes full case review, USPTO filing, and basic search. If your brand operates in a competitive space, we recommend the Business plan ($299) for comprehensive protection with a dedicated case manager."
  },
  {
    id: 4,
    question: "Why should I hire you instead of filing myself?",
    answer: "Because 30%+ of self-filed applications get rejected. One wrong classification, one missed conflict, one poorly worded description, and you lose your filing fees and wait 12 months for nothing. Our attorneys have filed thousands of successful applications. We know what the USPTO wants."
  },
  {
    id: 5,
    question: "Do I need a trademark for Amazon Brand Registry?",
    answer: "Yes. Amazon requires a federally registered trademark (or pending application with a serial number). Without it, you cannot access Brand Registry, A+ Content, Sponsored Brands, or automated IP protection. We handle both the trademark filing and Brand Registry enrollment."
  },
  {
    id: 6,
    question: "What if my application gets an office action (rejection)?",
    answer: "We fight it. Our attorneys analyze the objection, build strategic legal arguments, and file a comprehensive response. Business and Enterprise clients get this at no extra cost. We don't give up on your application."
  },
  {
    id: 7,
    question: "What's the difference between trademark and copyright?",
    answer: "Trademarks protect your brand identity: names, logos, slogans. Copyrights protect creative works: images, content, designs. Amazon sellers need both. A trademark for Brand Registry, and copyrights to protect product listings from content thieves."
  },
  {
    id: 8,
    question: "How much do USPTO government fees cost?",
    answer: "USPTO charges $250-$350 per trademark class, paid directly to the government. This is separate from our service fee. We'll identify the right classes during consultation so you don't overpay or under-protect your brand."
  },
  {
    id: 9,
    question: "Can I register a trademark without forming an LLC?",
    answer: "Yes, individuals can file. But if you're serious about your business, an LLC provides liability protection and professional credibility. We offer combined LLC + trademark packages that save you time and money."
  },
  {
    id: 10,
    question: "What happens after my trademark is approved?",
    answer: "You receive a federal registration certificate and can use the registered symbol. Your trademark is protected across all 50 states. We also offer monitoring services to catch anyone trying to register similar marks. Protection doesn't stop at approval."
  }
];

export const countryCodes = [
  { code: '+1', country: 'US/Canada', flag: '\u{1f1fa}\u{1f1f8}' },
  { code: '+44', country: 'UK', flag: '\u{1f1ec}\u{1f1e7}' },
  { code: '+91', country: 'India', flag: '\u{1f1ee}\u{1f1f3}' },
  { code: '+86', country: 'China', flag: '\u{1f1e8}\u{1f1f3}' },
  { code: '+81', country: 'Japan', flag: '\u{1f1ef}\u{1f1f5}' },
  { code: '+49', country: 'Germany', flag: '\u{1f1e9}\u{1f1ea}' },
  { code: '+33', country: 'France', flag: '\u{1f1eb}\u{1f1f7}' },
  { code: '+39', country: 'Italy', flag: '\u{1f1ee}\u{1f1f9}' },
  { code: '+61', country: 'Australia', flag: '\u{1f1e6}\u{1f1fa}' },
  { code: '+55', country: 'Brazil', flag: '\u{1f1e7}\u{1f1f7}' },
  { code: '+52', country: 'Mexico', flag: '\u{1f1f2}\u{1f1fd}' },
  { code: '+7', country: 'Russia', flag: '\u{1f1f7}\u{1f1fa}' },
  { code: '+82', country: 'South Korea', flag: '\u{1f1f0}\u{1f1f7}' },
  { code: '+34', country: 'Spain', flag: '\u{1f1ea}\u{1f1f8}' },
  { code: '+31', country: 'Netherlands', flag: '\u{1f1f3}\u{1f1f1}' },
  { code: '+46', country: 'Sweden', flag: '\u{1f1f8}\u{1f1ea}' },
  { code: '+47', country: 'Norway', flag: '\u{1f1f3}\u{1f1f4}' },
  { code: '+41', country: 'Switzerland', flag: '\u{1f1e8}\u{1f1ed}' },
  { code: '+65', country: 'Singapore', flag: '\u{1f1f8}\u{1f1ec}' },
  { code: '+971', country: 'UAE', flag: '\u{1f1e6}\u{1f1ea}' },
  { code: '+966', country: 'Saudi Arabia', flag: '\u{1f1f8}\u{1f1e6}' },
  { code: '+27', country: 'South Africa', flag: '\u{1f1ff}\u{1f1e6}' },
  { code: '+64', country: 'New Zealand', flag: '\u{1f1f3}\u{1f1ff}' },
  { code: '+351', country: 'Portugal', flag: '\u{1f1f5}\u{1f1f9}' },
  { code: '+48', country: 'Poland', flag: '\u{1f1f5}\u{1f1f1}' },
  { code: '+20', country: 'Egypt', flag: '\u{1f1ea}\u{1f1ec}' },
  { code: '+90', country: 'Turkey', flag: '\u{1f1f9}\u{1f1f7}' },
  { code: '+62', country: 'Indonesia', flag: '\u{1f1ee}\u{1f1e9}' },
  { code: '+63', country: 'Philippines', flag: '\u{1f1f5}\u{1f1ed}' },
  { code: '+66', country: 'Thailand', flag: '\u{1f1f9}\u{1f1ed}' },
  { code: '+60', country: 'Malaysia', flag: '\u{1f1f2}\u{1f1fe}' },
  { code: '+84', country: 'Vietnam', flag: '\u{1f1fb}\u{1f1f3}' },
  { code: '+92', country: 'Pakistan', flag: '\u{1f1f5}\u{1f1f0}' },
  { code: '+880', country: 'Bangladesh', flag: '\u{1f1e7}\u{1f1e9}' },
  { code: '+94', country: 'Sri Lanka', flag: '\u{1f1f1}\u{1f1f0}' },
  { code: '+977', country: 'Nepal', flag: '\u{1f1f3}\u{1f1f5}' },
  { code: '+234', country: 'Nigeria', flag: '\u{1f1f3}\u{1f1ec}' },
  { code: '+254', country: 'Kenya', flag: '\u{1f1f0}\u{1f1ea}' },
  { code: '+233', country: 'Ghana', flag: '\u{1f1ec}\u{1f1ed}' },
  { code: '+212', country: 'Morocco', flag: '\u{1f1f2}\u{1f1e6}' },
  { code: '+213', country: 'Algeria', flag: '\u{1f1e9}\u{1f1ff}' },
  { code: '+216', country: 'Tunisia', flag: '\u{1f1f9}\u{1f1f3}' },
  { code: '+353', country: 'Ireland', flag: '\u{1f1ee}\u{1f1ea}' },
  { code: '+43', country: 'Austria', flag: '\u{1f1e6}\u{1f1f9}' },
  { code: '+32', country: 'Belgium', flag: '\u{1f1e7}\u{1f1ea}' },
  { code: '+45', country: 'Denmark', flag: '\u{1f1e9}\u{1f1f0}' },
  { code: '+358', country: 'Finland', flag: '\u{1f1eb}\u{1f1ee}' },
  { code: '+30', country: 'Greece', flag: '\u{1f1ec}\u{1f1f7}' },
  { code: '+36', country: 'Hungary', flag: '\u{1f1ed}\u{1f1fa}' },
  { code: '+420', country: 'Czech Republic', flag: '\u{1f1e8}\u{1f1ff}' },
  { code: '+40', country: 'Romania', flag: '\u{1f1f7}\u{1f1f4}' },
  { code: '+380', country: 'Ukraine', flag: '\u{1f1fa}\u{1f1e6}' },
  { code: '+972', country: 'Israel', flag: '\u{1f1ee}\u{1f1f1}' },
  { code: '+962', country: 'Jordan', flag: '\u{1f1ef}\u{1f1f4}' },
  { code: '+961', country: 'Lebanon', flag: '\u{1f1f1}\u{1f1e7}' },
  { code: '+964', country: 'Iraq', flag: '\u{1f1ee}\u{1f1f6}' },
  { code: '+98', country: 'Iran', flag: '\u{1f1ee}\u{1f1f7}' },
  { code: '+993', country: 'Turkmenistan', flag: '\u{1f1f9}\u{1f1f2}' },
  { code: '+56', country: 'Chile', flag: '\u{1f1e8}\u{1f1f1}' },
  { code: '+57', country: 'Colombia', flag: '\u{1f1e8}\u{1f1f4}' },
  { code: '+54', country: 'Argentina', flag: '\u{1f1e6}\u{1f1f7}' },
  { code: '+51', country: 'Peru', flag: '\u{1f1f5}\u{1f1ea}' },
  { code: '+58', country: 'Venezuela', flag: '\u{1f1fb}\u{1f1ea}' },
  { code: '+593', country: 'Ecuador', flag: '\u{1f1ea}\u{1f1e8}' },
  { code: '+974', country: 'Qatar', flag: '\u{1f1f6}\u{1f1e6}' },
  { code: '+973', country: 'Bahrain', flag: '\u{1f1e7}\u{1f1ed}' },
  { code: '+968', country: 'Oman', flag: '\u{1f1f4}\u{1f1f2}' },
  { code: '+965', country: 'Kuwait', flag: '\u{1f1f0}\u{1f1fc}' },
  { code: '+852', country: 'Hong Kong', flag: '\u{1f1ed}\u{1f1f0}' },
  { code: '+886', country: 'Taiwan', flag: '\u{1f1f9}\u{1f1fc}' },
  { code: '+853', country: 'Macau', flag: '\u{1f1f2}\u{1f1f4}' },
];
